module.exports = __webpack_public_path__ + "img/service (1).8a5bd588.png";